import {doc} from '../docs.js';
import JRepl from '../../custom/JRepl.js';

doc(
    "jrepl",
    {
    },
    "Analyze & control underlying tidal patterns in a jaki object",
    () => 0,
    {
        inlets: 0
    });

export const jrepl = (object) => {
    let effect = new JRepl(object);

    return () => {
    };
};
